import {Component} from '@angular/core';
import {ActivatedRoute} from '../../../node_modules/@angular/router';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
})
export class NotFoundComponent {


    constructor(private route: ActivatedRoute) {
        window.location.href = 'https://servizitaliagroup.com/404';
    }

}
